import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Vuex from 'vuex'
import {store} from './services/store'
import Router from 'vue-router'
import routes from './routes';
import moment from 'moment-timezone'
import VueMoment from 'vue-moment';
import Multiselect from 'vue-multiselect'
import VueSweetalert2 from 'vue-sweetalert2';
import VueFeather from 'vue-feather';
import * as VueGoogleMaps from "vue2-google-maps";
import './assets/css/tailwind.css';
//import VueTailwindModal from "vue-tailwind-modal"
import VueTailwindModal from "vue-tailwind-modal/src/VueTailwindModal.vue";

Vue.component("VueTailwindModal", VueTailwindModal)
Vue.use(VueSweetalert2);
import JsonCSV from 'vue-json-csv'

Vue.component('multiselect', Multiselect)
Vue.component('downloadCsv', JsonCSV)

Vue.use(VueGoogleMaps, {
    load: {
        key: "AIzaSyB7AI-QHSabUVJGi94yevh5HZGjp8YQlzI",
        libraries: 'places,drawing,visualization'
    }
});

import VueKonva from 'vue-konva'

Vue.use(VueKonva)

import heatmap from 'vue-heatmapjs'

Vue.use(heatmap)

//sidenav menu
import VueSidebarMenu from 'vue-sidebar-menu'

Vue.use(VueSidebarMenu)

Vue.use(VueFeather);
Vue.use(VueMoment, {moment});
Vue.use(Router, VueAxios, axios, Vuex);
// axios.defaults.headers = { 
//     "Authorization": "Bearer " + store.getters.apiToken,
//     "orgId": store.getters.orgId
// };
axios.interceptors.request.use(config => {
  const token = store.getters.apiToken;
  const orgId = store.getters.orgId;

  // Do NOT attach auth headers to login endpoint
  if (!config.url.includes('ads.brandfi.co.ke')) {
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    if (orgId) {
      config.headers['orgId'] = orgId;
    }
  } 

  return config;
}, error => Promise.reject(error));

//import axios from 'axios'
//import store from './store'
//import router from './router'

axios.interceptors.response.use(
    response => response,
    error => {
        if (error.response && error.response.status === 401) {
            // User is cooked. Their token is expired or invalid.
            store.dispatch('logout')   // clear tokens, user data, etc.
            router.push({
                path: '/login',
                query: { nextUrl: router.currentRoute.fullPath }
            })
        }

        return Promise.reject(error)
    }
)


Vue.prototype.axios = axios;
window.axios = require('axios');
Vue.config.productionTip = false;
const router = new Router({mode: 'history', routes: routes});
// router.beforeEach((to, from, next) => {
//     if (to.path === '/logout') {
//         store.dispatch('login', null);
//         next({path: '/login', params: {nextUrl: to.fullPath}})
//     } else if (to.matched.some(record => record.meta.guest))
//         next(store.getters.loggedIn ? {path: '/', params: {nextUrl: to.fullPath}} : {});
//     else if (to.matched.some(record => record.meta.requiresAuth)) {
//         if (!store.getters.loggedIn)
//             store.dispatch("setRedirectUrl", to.fullPath);
//         next(store.getters.loggedIn ? {} : {path: '/login', params: {nextUrl: to.fullPath}});
//     } else
//         next()
// });
 
router.beforeEach((to, from, next) => {
    const loggedIn = store.getters.loggedIn;

    // Handle logout route
    if (to.path === '/logout') {
        store.dispatch('login', null);
        return next({
            path: '/login',
            params: { nextUrl: to.fullPath }
        });
    }
      
    // Guest-only routes (e.g. login/register)
    if (to.matched.some(record => record.meta.guest)) {
        if (loggedIn) {
            return next({
                path: '/1a998973-b398-4984-a4e7-f0487fdcc985/',
                params: { nextUrl: to.fullPath }
            });
        }
        return next(); // allow guest access
    }

    // Auth-protected routes
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!loggedIn) {
            store.dispatch("setRedirectUrl", to.fullPath);
            return next({
                path: '/login',
                params: { nextUrl: to.fullPath }
            });
        }
        return next(); // user is logged in
    }

    // Default release
    next();
});


new Vue({
    render: h => h(App), store, router
}).$mount('#app')
